import(/* webpackMode: "eager" */ "/home/jenkins/agent/workspace/epb-only-nodejs-4e95220b-b0e6-44eb-b82c-95d5f6bafe41/apps/spot-fe-byvotes-next/app/page.tsx")